import { CommonModule } from '@angular/common';
import {
    Component,
    EventEmitter,
    Inject,
    Input,
    Optional,
    Output,
} from '@angular/core';
import { DatiqAppStateService } from '@dat/datiq-app/data';
import { DatiqMenuModule } from '@dat/datiq-components-pkg/menu';
import { IDatiqAction } from '@dat/datiq-core/models';
import { noop } from 'lodash';
import { IDatiqCellActionService, datiqCellActionToken } from '../models';
import { IDatiqCellMenu, IDatiqCellMenuItem } from './models';

@Component({
    selector: 'datiq-cell-menu',
    standalone: true,
    imports: [CommonModule, DatiqMenuModule],
    templateUrl: './datiq-cell-menu.component.html',
    styleUrls: ['./datiq-cell-menu.component.scss'],
})
export class DatiqCellMenuComponent {
    @Input() settings: IDatiqCellMenu;

    @Output() itemClicked: EventEmitter<IDatiqAction> =
        new EventEmitter<IDatiqAction>();

    constructor(
        @Optional()
        @Inject(datiqCellActionToken)
        private _service: IDatiqCellActionService,
        @Optional() private _app: DatiqAppStateService
    ) {}

    menuItemClicked(menuItem: IDatiqCellMenuItem): void {
        !!this._service
            ? this._service.fireAction(menuItem.data as IDatiqAction)
            : !!this._app
            ? this._app.fireAction(menuItem.data as IDatiqAction)
            : noop();
        this.itemClicked.emit(menuItem.data as IDatiqAction);
    }
}
